import React, { createContext, useEffect, useState } from "react";
import { ApiPromise, WsProvider } from "@polkadot/api";
import { options } from "@acala-network/api";
import {
  InjectedAccountWithMeta,
  InjectedExtension,
} from "@polkadot/extension-inject/types";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";
import Step4 from "./components/Step4";
import Success from "./components/Success";
import "./index.css";
import { ethers } from "ethers";

interface Extensions {
  substrate: InjectedExtension;
  ethereum: ethers.providers.Web3Provider;
}

export const ExtensionsContext = createContext<Extensions | null>(null);
export const ApiContext = createContext<ApiPromise | null>(null);

const App: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [substrateApi, setSubstrateApi] = useState<ApiPromise | null>(null);
  const [substrateAccount, setSubstrateAccount] =
    useState<InjectedAccountWithMeta | null>(null);
  const [ethAddress, setEthAddress] = useState<string | null>(null);
  const [claimSignature, setClaimSignature] = useState<string | null>(null);

  useEffect(() => {
    let api: ApiPromise | null = null;
    const initSubstrateApi = async () => {
      const provider = new WsProvider("wss://mandala.polkawallet.io");
      api = await ApiPromise.create(options({ provider }));
      setSubstrateApi(api);
    };

    initSubstrateApi();

    return () => {
      if (api) {
        api.disconnect();
      }
    };
  }, []);

  const stepComplete = () => {
    const nextStep = document.getElementById(`step-${currentStep + 1}`);

    if (nextStep) {
      nextStep?.scrollIntoView({ behavior: "smooth" });
    }

    setCurrentStep(currentStep + 1);
  };

  return (
    <div className="flex flex-col justify-center items-center w-screen min-h-screen bg-gray-200">
      <div className="flex flex-col gap-6 my-16">
        <Step1
          setCurrentStep={setCurrentStep}
          currentStep={currentStep}
          setSubstrateAccount={setSubstrateAccount}
        />
        <Step2
          currentStep={currentStep}
          stepComplete={(address) => {
            setEthAddress(address);
            stepComplete();
          }}
        />
        <Step3
          currentStep={currentStep}
          stepComplete={(signature: string) => {
            setClaimSignature(signature);
            stepComplete();
          }}
          substrateAccount={substrateAccount}
          ethAddress={ethAddress!}
        />

        <Step4
          currentStep={currentStep}
          stepComplete={stepComplete}
          signature={claimSignature!}
          substrateAccount={substrateAccount}
          substrateApi={substrateApi}
          ethAddress={ethAddress!}
        />
      </div>
      {currentStep === 5 ? (
        <Success
          substrateAccount={substrateAccount!}
          ethAddress={ethAddress!}
        />
      ) : (
        <div />
      )}
    </div>
  );
};

export default App;
